import { useState } from 'react';

import { BuildData, LogData } from './useFetchLog';
import useFetchNextLogs from './useFetchNextLogs';
import useFetchPrevLogs from './useFetchPrevLogs';

type UseBuildLogResponse = {
  isFirstChunkLoaded: boolean;
  logString: string;
  status: number | undefined;
  isArchived: boolean;
};

const useBuildLog = (buildData: BuildData): UseBuildLogResponse => {
  const [nextBeforeTimestamp, setNextBeforeTimestamp] = useState<string | undefined>(undefined);
  const [nextAfterTimestamp, setNextAfterTimestamp] = useState<string | undefined>(undefined);
  const [archivedLog, setArchivedLog] = useState<string>('');
  const [logStrings, setLogStrings] = useState<string[]>([]);
  const [isFirstChunkLoaded, setFirstChunkLoaded] = useState<boolean>(false);

  const logData: LogData = {
    archivedLog,
    isFirstChunkLoaded,
    logStrings,
    nextAfterTimestamp,
    nextBeforeTimestamp,
    setArchivedLog,
    setFirstChunkLoaded,
    setNextAfterTimestamp,
    setNextBeforeTimestamp,
    setLogStrings,
  };
  const { errorStatus: prevLogErrorStatus } = useFetchPrevLogs({ buildData, logData });
  const { errorStatus: nextLogErrorStatus, isArchived } = useFetchNextLogs({ buildData, logData });

  return {
    status: nextLogErrorStatus ?? prevLogErrorStatus,
    isFirstChunkLoaded,
    isArchived,
    logString: logData.archivedLog || logData.logStrings.join(''),
  };
};

export default useBuildLog;
